import { Feature, Geometry } from '@turf/helpers';

export interface ILocationShapeAPI {
  locationshape_id: number;
  country_id?: number;
  created_on_utc?: string;
  geometry?: Geometry;
  location_id?: number;
  modified_on_utc?: string;
  name?: string;
  region_id?: number;
  source?: string;
}

interface ILocationShape {
  id: number;
  countryID: number;
  createdOnUtc: string;
  geometry: Geometry;
  locationID: number;
  modifiedOnUtc: string;
  name: string;
  regionID: number;
  source: string;
}

export default class LocationShape {
  id: number;

  countryID: number;

  createdOnUtc: string;

  geometry: Geometry;

  locationID: number;

  modifiedOnUtc: string;

  name: string;

  regionID: number;

  source: string;

  constructor(
    id = -1,
    countryID: number,
    createdOnUtc: string,
    geometry,
    locationID: number,
    modifiedOnUtc: string,
    name: string,
    regionID: number,
    source: string,
  ) {
    this.id = id;
    this.countryID = countryID;
    this.createdOnUtc = createdOnUtc;
    this.geometry = geometry;
    this.locationID = locationID;
    this.modifiedOnUtc = modifiedOnUtc;
    this.name = name;
    this.regionID = regionID;
    this.source = source;
  }

  get feature(): Feature {
    return {
      type: 'Feature',
      geometry: this.geometry,
      properties: [],
    };
  }

  static fromApi(apiObject: ILocationShapeAPI): LocationShape {
    return new LocationShape(
      apiObject.locationshape_id,
      apiObject.country_id,
      apiObject.created_on_utc,
      apiObject.geometry,
      apiObject.location_id,
      apiObject.modified_on_utc,
      apiObject.name,
      apiObject.region_id,
      apiObject.source,
    );
  }

  static fromObject(obj: ILocationShape): LocationShape {
    return new LocationShape(
      obj.id,
      obj.countryID,
      obj.createdOnUtc,
      obj.geometry,
      obj.locationID,
      obj.modifiedOnUtc,
      obj.name,
      obj.regionID,
      obj.source,
    );
  }

  toApi(): ILocationShapeAPI {
    return {
      locationshape_id: this.id >= 0 ? this.id : undefined,
    };
  }

  static validatorCreateRules(): Record<string, string> {
    return {};
  }
}
